
import { Options, Vue } from "vue-class-component";
import {
  isSuperposColorPiece,
  isFullySetSuperposColorPiece,
} from "@/GameLogic";
import { GameState, Piece } from "@/GameState";
import { computeWorldOccupationFilter, playerToColor } from "@/GameVisual";

interface Highlight {
  column: number;
  row: number;
  piece: Piece;
}
@Options({
  props: {
    state: Object,
  },
  data() {
    return {
      preparedColumn: undefined,
      highlight: undefined,
    };
  },
  emits: ["placeClassical", "placeSpace", "placeColor", "manualCollapse"],
})
export default class GameBoard extends Vue {
  state!: GameState;
  preparedColumn?: number;
  highlight?: Highlight;

  getPieceActionHint(p: Piece): string {
    if (isSuperposColorPiece(p)) {
      if (isFullySetSuperposColorPiece(p)) {
        return this.state.playerAllowedCollapses >= 1
          ? "Click this to collapse it to " +
              playerToColor(this.state.next_player)
          : "You have no collapses left before your move.";
      } else {
        return "You need to choose a position for the other piece first";
      }
    } else if (!p.stable) {
      return this.state.playerAllowedCollapses >= 1
        ? "Click to collapse here"
        : "You have no collapses left before your move.";
    }

    return "";
  }

  getActionPieceDebug(piece: Piece): string {
    return process.env.NODE_ENV === "production"
      ? ""
      : `
ID: ${piece.id}
player: ${piece.player1} ${playerToColor(piece.player1)}
stable: ${piece.stable}
colorID: ${piece.colorID}
colorORef: ${piece.colorPieceOther}
allowedCollapses: ${this.state.playerAllowedCollapses}`;
  }

  prepare(column: number) {
    this.preparedColumn = column;
  }
  placeClassical(column: number) {
    this.$emit("placeClassical", column);
    this.preparedColumn = undefined;
  }
  placeColor(column: number) {
    this.$emit("placeColor", column);
    this.preparedColumn = undefined;
  }
  placeSpace(column: number) {
    this.$emit("placeSpace", this.preparedColumn, column);
    this.preparedColumn = undefined;
  }

  collapse(column: number, row: number, piece: Piece) {
    // reject
    if (this.state.playerAllowedCollapses < 1) {
      return;
    }

    // only keep worlds where piece is in (column, row)
    // ignore events, where the piece is already stable
    if (!piece.stable || piece.colorPieceOther !== undefined) {
      this.$emit("manualCollapse", column, row, piece);
      this.highlight = undefined;
    }
  }

  get highlightOccupancy() {
    // no highlight occupation for color superposition or stable pieces
    return this.highlight === undefined ||
      this.highlight.piece.stable ||
      this.highlight.piece.colorID !== undefined
      ? {}
      : computeWorldOccupationFilter(
          this.state,
          this.highlight.column,
          this.highlight.row,
          this.highlight.piece
        );
  }
}
